import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";
import { withShop } from "./web/shopfixes.js";

const PricingPage = withShop(lazy(() => import("./web/PricingPage.js").then((m) => ({ default: m.PricingPage }))));
const ChangesPage = withShop(lazy(() => import("./web/PricingPage.js").then((m) => ({ default: m.ChangesPage }))));
const BandsPage = withShop(lazy(() => import("./web/BandsPage.js").then((m) => ({ default: m.BandsPage }))));
const RrpPage = withShop(lazy(() => import("./web/RrpPage.js").then((m) => ({ default: m.RrpPage }))));

export default defineWebModule({ manifest, pages: { "": PricingPage, "/changes": ChangesPage, "/bands": BandsPage, "/rrp": RrpPage } });
